import styled from 'styled-components';

export const AttachmentsContainer = styled.div`
    border-bottom: 1px solid var(--theme-eml-subject-border);
    padding: .4em;
`;
